module.exports = __webpack_public_path__ + "img/logo-clean.e81d64e6.jpg";